import theme from "../theme";

export default function NotFound() {
    return (
        <div className="flex justify-center items-center h-screen" style={{ fontFamily: theme.typography.main_jp.fontFamily }}>
            <p className="text-center text-2xl">ページが見つかりません。</p>
            <a href="/">TOP</a>
        </div>
    );
}